import { jsx as _jsx } from "react/jsx-runtime";
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import { Snackbar } from '../../components/Snackbar/Snackbar';
import { snackbarConfigContext } from '../SnackbarConfigContext/SnackbarConfigContext';
const MAX_SNACKBAR_COUNT = 2;
const getNotistackSnackbarProviderProps = (maxSnack, anchorOrigin) => ({
    Components: {
        default: Snackbar,
        error: Snackbar,
        info: Snackbar,
        success: Snackbar,
        warning: Snackbar,
    },
    maxSnack,
    anchorOrigin,
});
export const SnackbarProvider = ({ children, config, maxSnack = MAX_SNACKBAR_COUNT, anchorOrigin, }) => {
    const notistackSnackbarProviderProps = getNotistackSnackbarProviderProps(maxSnack, anchorOrigin);
    return (_jsx(snackbarConfigContext.Provider, { value: config, children: _jsx(NotistackSnackbarProvider, { ...notistackSnackbarProviderProps, children: children }) }));
};
